import { MdArrowBackIos } from "react-icons/md";
import "./IssuePage.scss";
import { useNavigate } from "react-router-dom";
import { IssueCard } from "./IssueCard";
export interface IssueData {
  _id: string;
  Unique_Id: string;
  createdAt: string;
  UserName: string;
  Issue_Related_To: string;
  Issue_Subject: string;
  Issue_Details: string;
  Name: string;
  Doc_1?: string;
  Doc_2?: string;
  Doc_3?: string;
  Doc_4?: string;
}
export const IssuePage = ({ data, title, modal }: { data: IssueData[]; title: string; modal: boolean }) => {
  const history = useNavigate();
  return (
    <>
      <div className="issuePageContainer">
        <div className="actionContainer">
          <div onClick={() => history(-1)}>{!modal && <MdArrowBackIos />}</div>
          <p>{title}</p>
        </div>
        <div>
          {!data?.length && <p className="DataNotAvailable">Data not Available</p>}
          {/* <hr className="issueHr"/> */}
          {data?.map((item: IssueData) => {
            return (
              <IssueCard
                _id={item._id}
                Unique_Id={item.Unique_Id}
                createdAt={item.createdAt}
                UserName={item.UserName}
                Name={item.Name}
                Issue_Related_To={item.Issue_Related_To}
                Issue_Subject={item.Issue_Subject}
                Issue_Details={item.Issue_Details}
                Title={title}
                Doc_1={item.Doc_1}
                Doc_2={item.Doc_2}
                Doc_3={item.Doc_3}
                Doc_4={item.Doc_4}
                modal={modal}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};
